export default __webpack_public_path__ + "static/media/Screenshot_14.d3f58773.png";